import { LineChart, Line, ResponsiveContainer, Tooltip } from "recharts";
import { money, monthLabel } from "../lib/format";

export function MerchantTrend({ points, testId }) {
  if (!points || points.length < 2) return <div className="text-right text-[11px] font-mono text-slate-400" data-testid={testId}>first month</div>;
  const last = points[points.length - 1].residual, prev = points[points.length - 2].residual;
  const change = prev ? ((last - prev) / Math.abs(prev)) * 100 : null;
  const up = last >= prev;
  const color = up ? "#10B981" : "#F43F5E";
  return (
    <div className="flex items-center justify-end gap-2" data-testid={testId}>
      <div className="w-20 h-7">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={points.map((p) => ({ ...p, label: monthLabel(p.month) }))}>
            <Tooltip labelStyle={{ color: "#F1F5F9" }} itemStyle={{ color: "#E2E8F0" }} contentStyle={{ background: "#131B2E", border: "1px solid #1E293B", fontSize: 11, fontFamily: "JetBrains Mono" }}
              labelFormatter={(_, p) => p?.[0]?.payload?.label} formatter={(v) => [money(v), "Residual"]} />
            <Line type="monotone" dataKey="residual" stroke={color} strokeWidth={1.5} dot={false} />
          </LineChart>
        </ResponsiveContainer>
      </div>
      <span className={`font-mono text-[11px] w-14 text-right ${up ? "text-emerald-400" : "text-rose-400"}`}>
        {change == null ? "new" : `${up ? "▲" : "▼"} ${Math.abs(change).toFixed(0)}%`}
      </span>
    </div>
  );
}
